
import { ElForm } from 'element-ui/types/form'
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services'

@Component({})
export default class EventCombine extends Vue {
    private pageTotal = 0
    private pageIndex = 1
    private pageSize = 10
    private combineForm = {
        mainId: '',
        passiveIds: [{ value: '', key: +new Date() }]
    }
    private combineRules = {
        mainId: [
            { required: true, message: '请输入主事件id' }
        ]
    }
    get combineFormRef() {
        return this.$refs.combineForm as ElForm
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
    }

    private onCombine() {
        this.combineFormRef.validate(isValid => {
            if (isValid) {
                this.$confirm('你正在合并事件, 确定继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.combineEvent()
                }).catch()
            }
        })
    }
    private async combineEvent() {
        const params = {
            master_id: +this.combineForm.mainId,
            merge_ids: this.combineForm.passiveIds.map(id => +id.value)
        }
        const result = await CommonService.combineEvent(params)
        if (result.status === 200) {
            this.combineFormRef.clearValidate()
            this.combineFormRef.resetFields()
            this.$message({
                type: 'success',
                message: '合并成功',
                showClose: true
            })
        }
    }
    private addEvent() {
        this.combineForm.passiveIds.push({
            value: '',
            key: Date.now()
        })
    }
    private removeEvent(eventId: any) {
        let index = this.combineForm.passiveIds.indexOf(eventId)
        if (index !== -1) {
            this.combineForm.passiveIds.splice(index, 1)
        }
    }
}
